import React from 'react';
// import { Link } from "react-router-dom";
import SearchResumes from '../components/SearchResumes.jsx';
// import UserResumes from '../components/UserResumes.jsx';
import '../styles/Home.css'

const OpeningManager = () => {

    return (
        <div className='App'>
            <div className='home'>
                <div className='homeBlock' data-test="userData">
                    <SearchResumes />
                </div>
                {/* <div className='homeBlock'>
                    <UserResumes />
                </div> */}
            </div>
        </div >
    );
}

export default OpeningManager;